// extracted by mini-css-extract-plugin
export default {"selector":"groupSelector_selector__f-qbJ"};